import { render, staticRenderFns } from "./LocationNav.vue?vue&type=template&id=cdaf66aa&"
import script from "./LocationNav.vue?vue&type=script&lang=js&"
export * from "./LocationNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports